import { InjectionToken } from '@angular/core';

import type { NotificationsPort } from './notifications.port';

/**
 * Frontera de composición: token que resuelve el `NotificationsPort`. El binding a
 * la implementación HTTP se hace en `notifications.providers.ts` (composition root),
 * que `provideCore()` monta a nivel raíz (la campana vive en el shell, no en una ruta).
 */
export const NOTIFICATIONS_PORT = new InjectionToken<NotificationsPort>('NOTIFICATIONS_PORT');
